import { Component, Inject, OnInit } from '@angular/core';
import { CopyReport } from './copy-report.types';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { AlertMessageService } from 'app/core/common/alert.message.service';
import { InwardsService } from 'app/modules/admin/transactions/inwards/inwards.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-copy-report',
  templateUrl: './copy-report.component.html',
  styleUrls: ['./copy-report.component.scss']
})
export class CopyReportComponent implements OnInit {

  dialogTitle = `Copy Report`
  copyReportForm: FormGroup;
  copyReport: CopyReport;
  alert: any;

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
    private _formBuilder: FormBuilder,
    private _matDialogRef: MatDialogRef<CopyReportComponent>,
    private _alertMessage: AlertMessageService,
    private _inwardsService: InwardsService,
    private _matDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) private _data
  ) {
    this.copyReportForm = this._formBuilder.group({
      fromJobNumber: ['', [Validators.required]],
      toJobNumber: [this._data.jobNumber, [Validators.required]],
      copyNote: [''],
      copyReportType:['Same']
    });
  }

  ngOnInit(): void {
   // this.copyReport.copyReportType = "same"
  }
  saveAndClose() {
    const copyReport = this.copyReportForm.getRawValue();
    this._inwardsService.copyReport(copyReport).subscribe((response) => {
      if (response.isSuccess) {
        // Show a success message
        this._alertMessage.success("Report Copy successfully");
        // Close the dialog
        this._matDialogRef.close(response);
      }
      else {
        this._alertMessage.error(response.errors.join("\n"));
      }
    });
  }
  onClose(): void {
    this._matDialogRef.close();
  }
}
